import styled from 'styled-components';

export const Styles = styled.div`
    margin-bottom: ${({ $simple }) => ($simple ? '12px' : '20px')};

    & input {
        opacity: 1;
    }
`;
